import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { EncryptDecryptService } from 'src/app/Service/encrypt-decrypt.service';

@Component({
  selector: 'app-mail-redirect-handler',
  templateUrl: './mail-redirect-handler.component.html',
  styleUrls: ['./mail-redirect-handler.component.css']
})

export class MailRedirectHandlerComponent implements OnInit {

  private page!: string;
  private project!: string;
  private inputDocId!: string;
  private inputRevNo!: string;
  private inputMsgId!: string;
  private currentUrl: string ;
  private previousUrl!: string;

  constructor(private route: ActivatedRoute, private router: Router, private encryptDecryptService: EncryptDecryptService, private commonService: CommonService) {
    this.currentUrl = this.router.url;

    this.route.queryParams.subscribe(params => {
      this.page = params['page'];
      this.project = params['project'];
      this.inputDocId = params['doc'];
      this.inputRevNo = params['rev'];
      this.inputMsgId = params['msg'];
    });

    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
        this.previousUrl = this.currentUrl;
      };
    });

    let data = {
      page: this.page,
      project: this.project,
      inputDocId: this.inputDocId,
      inputRevNo: this.inputRevNo,
      inputMsgId: this.inputMsgId
    }

    this.commonService.setSessionStorageItem('requestedObject', this.encryptDecryptService.encrypt(JSON.stringify(data)));

    if (this.commonService.hasJWT()) {
      this.router.navigate(['/dashboard/home']);
    }
    else {
      this.router.navigate(['/authentication/login']);
    }
  }

  ngOnInit() {
  }

}